import { LoggerService } from '../shared/sdk/services/custom/logger.service';
import { Injectable } from '@angular/core';
import { Router, Resolve } from '@angular/router';
import { Organization } from '../shared/sdk/models';
import { EMPTY, Observable, of, Subscriber } from 'rxjs';

import { OrganizationService } from '../organizations/organization.service';
import { map, switchMap, take } from 'rxjs/operators';
import { DocumentService } from './document.service';
import { StorageService } from '../shared/services/storage.service';

@Injectable()
export class HasDocumentsResolver implements Resolve<number> {
  STORAGE_KEY = 'HasDocs';

  constructor(
    private documentService: DocumentService,
    private log: LoggerService,
    private orgService: OrganizationService,
    private router: Router,
    private storageService: StorageService,
  ) {}

  resolve(): Observable<number> {
    return new Observable((obs) => {
      this.log.log('HasDocuments: resolve');

      this.orgService.active
        .pipe(
          switchMap((organization: Organization) => {
            const storedCount = this.storageService.getItem(
              `${this.STORAGE_KEY}_${organization.id}`,
            );
            let count: Observable<number>;

            if (storedCount) {
              count = of(storedCount);
            } else {
              count = this.documentService.count(
                organization.id,
                {},
                true,
                false,
              );
            }

            return count.pipe(map((count) => ({ organization, count })));
          }),
          take(1),
        )
        .subscribe(
          ({ organization, count }) =>
            this.resolveHasDocuments(obs, organization, count),
          (err) => {
            this.log.log('HasDocuments: resolve error', err);
            this.router.navigate(['/']);
            obs.complete();
            return EMPTY;
          },
        );
    });
  }

  private resolveHasDocuments(
    obs: Subscriber<number>,
    organization: Organization,
    count: number,
  ) {
    this.log.log('HasDocuments: documents', count);
    this.storageService.setItem(
      this.STORAGE_KEY,
      `${this.STORAGE_KEY}_${organization.id}`,
    );

    obs.next(count);
    obs.complete();
  }
}
